// Godkänd preview gåva
$('#confirmButton').on('click', function() {
    const iframe = document.getElementById('donation-iframe');
    iframe.contentWindow.postMessage({confirmPreview: true}, '*')
})
$('#editLink').on('click', function() {
    const iframe = document.getElementById('donation-iframe');
    iframe.contentWindow.postMessage({confirmPreview: false}, '*')
})

$('.js-back-btn').on('click', function() {
    const iframe = document.getElementById('donation-iframe');
    iframe.contentWindow.postMessage({confirmPreview: false}, '*')
})

window.addEventListener("message", (event) => {
    const overlay = document.querySelector('.gift-overlay');
    const confirmPreview = overlay.querySelector('.confirm-preview-footer');
    const iframe = document.getElementById('donation-iframe');
    const modal = document.getElementById('gift-modal');
    const stickyTitle = document.querySelector('.sticky-navbar-title');
    const confirmToClose = overlay.querySelector('.close-confirmation');
    const confirmModalTitle = confirmToClose.querySelector('.js-close-title');
    const confirmModalYesBtn = confirmToClose.querySelector('.js-close');
    const confirmModalNoBtn = confirmToClose.querySelector('.js-not-close');

    let bottomOffset = 0;

    if (event.data.showConfirmBtn === true) {
        confirmPreview.style.display = 'flex';
    }
    if (event.data.showConfirmBtn === false) {
        confirmPreview.style.display = 'none';
    }

    if (event.data.scroll) {
        overlay.scrollTo(event.data.position.x, event.data.position.y)
    }

    if (event.data.slug) {
        const slugs = ['gift-page', 'memorial-gift', 'thanks-page', 'payment-page', 'monthlydebit-page'];
        const slug = event.data.slug;
        slugs.map(currentSlug => overlay.classList.remove(currentSlug));
        overlay.classList.add(slug)
    }

    if (event.data.openGiftChangeModal && event.data.giftType) {
        confirmToClose.style.display = 'block';
        overlay.style.overflow = 'hidden';
        confirmModalTitle.textContent = "Vill du byta gåvotyp?";
        confirmModalYesBtn.textContent = "Ja, byt";
        confirmModalNoBtn.textContent = "Nej";
        confirmToClose.dataset.giftType = event.data.giftType;
    }

    if (event.data.location && event.data.location.includes(event.origin)) {
        
        if (event.data.location.includes('=giftsubmit')) {
            window.history.pushState(null, null, '#payment');
            localStorage.setItem('payment', true)
        }
        if (event.data.location.includes('paymentDone')) {
            window.history.pushState(null, null, '#thanks');
            localStorage.setItem('thanks', true)
        }

        if (event.data.location.includes('/gift.php')){
            confirmPreview.style.display = 'none';
        }

        const observer = new ResizeObserver((entries) => {
            const iframeHeight = entries[0].contentRect.height
            const iframeWidth = entries[0].contentRect.width
            
            if (iframeWidth && iframeWidth < 430) {
                bottomOffset = 0;
            }

            if (iframeHeight !== 0) {
                modal.style.height = iframeHeight + bottomOffset + 'px'
            }
            // console.log(entries);
        })
        
        observer.observe(iframe.contentWindow.document.body);
    }
});


// WEBPACK FOOTER //
// ./_src/js/post_messages.js